import { useParams } from "react-router-dom";

/**
 * @returns {string}
 */
export const useSettingsCategoryFromRoute = () => {
  return useParams().category || "";
};
